export const PROFILE = {
  admin: 'admin',
  financial: 'financial',
  sales: 'sales',
  operations: 'operations'
};
